import { ServiceApi } from '../../utils/auth'

const state = {
    transactions: [],
    conversions: [],
    loading: false,
    error: null,
}

const actions = {
    // LIST COMPANY
    async fetchTransactions({ commit }, payload) {
        commit('transactionBegin')
        try {
            if (payload.company_id) {
                const res = await ServiceApi.get(`/api/company-points/${payload.company_id}`, payload.filter);
                commit("SET_TRANSACTIONS", res.data);
                commit('transactionSuccess', true)
                return res.data;
            } else if (!payload.company_id) {
                const res = await ServiceApi.get(`/api/user-points`, payload.filter);
                commit("SET_TRANSACTIONS", res.data);
                commit('transactionSuccess', true)
                return res.data;
            }
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },

    // LIST CONVERTIONS
    async fetchConversion({ commit }, payload) {
        commit('transactionBegin')
        try {
            const res = await ServiceApi.get(`/api/conversion-request`, payload);
            commit("SET_CONVERSION", res.data);
            commit('transactionSuccess', true)
            return res.data;
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },

     // APPROVE OR REJECT
     async approveOrReject({ commit }, payload) {
        commit('transactionBegin')
        try {
                const res = await ServiceApi.put(`/api/company-points/${payload.id}`, payload);
                commit('transactionSuccess', true)
                return res.data;
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },
}

const getters = {
    getTransactions: state => state.transactions,
    getConversions: state => state.conversions,
    transactionLoading: (state) => state.loading,
}

const mutations = {
    SET_TRANSACTIONS(state, payload) {
        state.transactions = payload.data.data
    },
    SET_CONVERSION(state, payload) {
        state.conversions = payload.data
    },
    transactionBegin(state) {
        state.loading = true
    },
    transactionSuccess(state) {
        state.loading = false
    },
    transactionErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
